<div class="negotiation-table">
    <app-negotiation-form-template #formTemplate [negotiationMode]="true"
                       [negotiationCustomerIds]="editableCustomerIds"
                       (formReady)="onFormReady()"
                       (formLoadError)="formLoadError.emit()"></app-negotiation-form-template>
  </div>
  